const mutations = {
    // Layout mutations
    SET_DASHBOARD_LAYOUT(state, { pageType, layout }) {
        state.dashboardLayouts = {
            ...state.dashboardLayouts,
            [pageType]: layout
        };
    },
    
    // Widget mutations
    SET_PAGE_WIDGETS(state, { pageType, widgets }) {
        state.pageWidgets = {
            ...state.pageWidgets,
            [pageType]: widgets
        };
    },
    
    // Widget CRUD mutations removed (backend configuration drives widget list)
    
    // Available widgets mutations
    SET_AVAILABLE_WIDGETS(state, { pageType, widgets }) {
        state.availableWidgets = {
            ...state.availableWidgets,
            [pageType]: widgets
        };
    },
    
    // Loading mutations
    SET_LOADING(state, { type, status }) {
        state.loading = {
            ...state.loading,
            [type]: status
        };
    },
    
    // Error mutations
    SET_ERROR(state, { type, error }) {
        state.errors = {
            ...state.errors,
            [type]: error
        };
    },
    
    CLEAR_ERRORS(state) {
        state.errors = {
            layout: null,
            widgets: null,
            save: null
        };
    },

    // Panel mutations
    SET_PANELS(state, { pageType, panels }) {
        state.panels = { ...state.panels, [pageType]: panels };
    },
    SET_ACTIVE_PANEL(state, { pageType, panelId }) {
        state.activePanel = { ...state.activePanel, [pageType]: panelId };
    },
    REMOVE_PANEL(state, { pageType, panelId }){
        const list = state.panels[pageType] ? state.panels[pageType].filter(p=>p.id!==panelId) : [];
        state.panels = { ...state.panels, [pageType]: list };
        if(state.activePanel[pageType]===panelId){ state.activePanel={ ...state.activePanel, [pageType]: list[0]?.id || null }; }
    }
    ,
    // Cache parsed panel configuration and widgets
    COMMIT_PANEL_DETAIL(state, { panelId, detail }) {
        state.panelDetails = { ...state.panelDetails, [panelId]: detail };
    },
    SET_QUEUES(state, queues) {
        state.queues = Array.isArray(queues) ? queues : []
    },
    SET_ACCOUNTS(state, accounts) {
        state.accounts = Array.isArray(accounts) ? accounts : []
    }
};

export default mutations;
